export default __webpack_public_path__ + "static/media/noImage.8874b81b.png";